import React, { useEffect, useState } from 'react';
import './index.scss';
import imgIcon from '../../../src/img/image-icon.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import vDOts from '../../../src/img/v-dots.png';
import '../../custom.js';
import Parameters from 'shared/parameters';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Modal,
    Switch,
    Input, Upload, Spin, Select, Skeleton,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import ReactQuill, { Quill } from 'react-quill';
import "react-quill/dist/quill.snow.css";
import { fillEn } from 'client/src/methods/forms';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    EyeFilled,
    EditFilled,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import deFlag from '../../../src/img/de-icon.png';
import enFlag from '../../../src/img/en-icon.png';

interface Props {
    location: any;
}

const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
export default function BadgeForm(props: Props) {
    const [deletingItem, setDeletingItem] = useState(false);
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const [lang, setLang] = useState('' as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchBadgeById(RouteParams['id']);
            setItem({
                ...data,
            });
             console.log(data)
            setImage({ image: getImageUrl(data.image), imageId: data.image_id });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const uploadImage = async (file: any) => {
        setUploading(true);
        setImage({ image: null, imageId: null });
        const { image, imageId, error } = await UploadImage(file);
        if (error) {
            notification.error({ message: error });
        }
        setImage({ image, imageId });
        setUploading(false);
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
        setLang(localStorage.getItem('language'));
    }, []);

    if (fetching) {
        return <Skeleton active={true}/>;
    }
    return (
        <div className={'list-page-wrapper'}>
            <div className="container-fluid">
                <div className={'d-flex justify-space-between mb-3'}>
                    <div className='col-md-12 p-0 d-flex align-items-center'>
                        <div className={lang == 'ar' ? '' : 'mr-4'}>
                        <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                        </div>
                        <div className={lang == 'ar' ? 'ml-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'create' ? t('badge.create') : ''}</h3></div>
                        <div className={lang == 'ar' ? 'mr-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'view' ? t('badge.profile') : ''}</h3></div>
                        <div className={lang == 'ar' ? 'mr-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'edit' ? t('badge.edit') : ''}</h3></div>
                    </div>
                </div>
                <div className={lang === 'ar' ? 'row text-right' : 'row'}>
                    <div className='col-md-12'>
                        
                        {RouteParams['mode'] === 'create' || RouteParams['mode'] === 'edit' ?
                        <div className='bg-white p-3 br-5px'>
                            <div className={lang === 'ar' ? 'pt-3 pb-3 pl-4' : 'pt-3 pb-3 pl-4 pr-6rem'}>
                            <Form
                                            size="large"
                                            form={form}
                                            initialValues={item}
                                            fields={[]}
                                            onFinish={(value) => {
                                                value.status = (value.status === true) ? 1 : 0;
                                                if (!image.imageId) {
                                                    notification.error({ message: t('image.required') });
                                                    return;
                                                }
                                                const reqObj: any = value;
                                                reqObj['image_id'] = image.imageId;
                                                console.log('reqObj',reqObj);
                                                // return
                                                setSaving(true);
                                                if (item && item.id) {
                                                    API_SERVICE.updateBadge(item.id, reqObj).then((d) => {
                                                        history.goBack();
                                                    }).catch((e) => {
                                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                                        setSaving(false);
                                                    });
                                                } else {
                                                    API_SERVICE.createBadge(reqObj).then((d) => {
                                                        history.goBack();
                                                    }).catch((e) => {
                                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                                        setSaving(false);
                                                    });
                                                }
                                            }}
                                            layout="vertical"
                                            requiredMark={true}
                                        >
                                <Row>
                                    <Col lg={10} md={10} sm={24} xs={24}>
                                    <h5 className={lang == 'ar' ? 'mr-4' : 'mt-4'}>{t('genDict.uploadBage')}</h5>
                                    <p className={lang == 'ar' ? 'mr-4' : 'text-secondary'}>{t('genDict.uploadParagraph')}</p>
                                    </Col>
                                    <Col lg={14} md={14} sm={24} xs={24}>
                                    {
                                        uploading ? <Spin/> : (
                                            image.image ? <div>
                                                
                                                <div className="d-flex align-items-center">
                                                    <div className="uploadeImgBg mr-2">
                                                        <Image src={image.image} id="orgLogo" className="uploaded-img-cat" height={'48px'} width={'48px'}/>
                                                    </div>
                                                    <div>
                                                        {
                                                            RouteParams['mode'] !== 'view' && <Button className='btn btn-default' onClick={() => setImage({
                                                                image: null,
                                                                imageId: null,
                                                            })}>{t('genDict.remove')}</Button>
                                                            
                                                        }
                                                    </div>
                                                </div>
                                                
                                            </div> : <Upload beforeUpload={(file) => {
                                                        if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                                            notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                                        }
                                                            uploadImage(file);
                                                            return file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
                                                        }}>
                                                        <div className={lang === 'ar' ? 'd-flex align-items-center gap-2': 'd-flex align-items-center'}>
                                                            <div className="mr-2">
                                                                    <img src={imgIcon} className="logo-org"/>
                                                                {/* <i className="fa fa-picture-o logo-org"></i> */}
                                                                {/* <img src="#" id="orgLogo" className="uploaded-img-cat" height="48" width="48" style={{display:'none'}}/> */}
                                                            </div>
                                                            <div>
                                                                <Button className="btn btn-default">{t('genDict.uploadImage')}</Button>
                                                            </div>
                                                        </div>
                                                    </Upload>
                                        )
                                    }
                                    </Col>
                                </Row>
                                <hr></hr>
                                <Row>
                                    <Col lg={10} md={10} sm={24} xs={24}>
                                    <h5 className={lang == 'ar' ? 'mr-4' : 'mt-4'}>{t('genDict.badgeInformation')}</h5>
                                    <p className={lang == 'ar' ? 'mr-4' : 'text-secondary'}>{t('genDict.badgeInformationParagraph')}</p>
                                    </Col>
                                    <Col lg={14} md={14} sm={24} xs={24}>
                                        
                                            
                                       
                                                <Form.Item
                                                    label={t('title.label')}
                                                    name={['title', selectedLang]}
                                                    rules={[
                                                        { required: true, message: t('title.required') },
                                                    ]}
                                                >
                                                    <Input className='form-control' disabled={RouteParams['mode'] === 'view'}/>
                                                </Form.Item>
                                           
                                                <Form.Item
                                                    // initialValue={item? item.description.de:''}
                                                    label={t('description.label')}
                                                    name={['description',selectedLang]}
                                                    rules={[
                                                        { required: true, message: t('description.required') },
                                                    ]}
                                                >
                                                    {RouteParams['mode'] === 'view'?
                                                    <Input className='form-control' disabled/>
                                                    :<TextArea className='form-control' cols={4}/>
                                                    }
                                                </Form.Item>
                                            
                                            <Form.Item
                                                initialValue= {item? item.status: false}
                                                label={t('active.label')}  
                                                name={'status'}    
                                                rules={[]}>
                                                {RouteParams['mode'] === 'view'?
                                                    <Switch disabled/>
                                                    :<Switch  defaultChecked={item?.status === 'ACTIVE' ? true : false }/>
                                                }
                                            </Form.Item>
                                            <Form.Item
                                                label={t('badge.numberOfCourses.label')}
                                                name={'no_of_courses'}
                                                rules={[
                                                    { required: true, message: t('badge.numberOfCourses.required') },
                                                ]}>
                                                <Input className='form-control' disabled={RouteParams['mode'] === 'view'}/>
                                            </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <hr/>
                                {
                                    RouteParams['mode'] !== 'view' && <Form.Item>
                                        <Button
                                            htmlType="submit"
                                            loading={saving || uploading}
                                            size={'large'}
                                            className="submit btn-blue float-right"
                                        >
                                            {t('genDict.save')}
                                        </Button>
                                        <Button                                 
                                            htmlType="reset"
                                            size={'large'}
                                            className="reset mr-3 btn-default float-right"
                                        >
                                            {t('genDict.cancel')}
                                        </Button>
                                    </Form.Item>
                                }
                                </Form>
                            </div>
                        </div>
                            :''
                        }
                        {RouteParams['mode'] === 'view' ?
                        <div className='bg-white p-3 br-5px'>
                            <div className="row">
                            <div className="col-sm-6 pb-3">
                                <div className="d-flex align-items-center">
                                    <div className="mr-3">
                                        <img src={image.image} className="uploaded-img-cat" height="50" width="50"/>
                                    </div>
                                    <div className="">
                                        <h5 className="mb-0 font-18px">
                                            <span>{
                                                    Parameters.DefaultLang === 'de' ? item.title.de : ''
                                                }
                                                {
                                                    Parameters.DefaultLang === 'en' ? item.title.en : ''
                                                }
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="col-sm-6 pb-3 text-sm-right my-auto">
                                <span className="text-secondary mr-4">{t('genDict.CreatedOn')} 24 June, 2021</span>
                                <span className="text-secondary mr-4">{item.created_at}</span>
                                <span className="dropdown">
                                    <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                                        <img src={vDOts} style={{width: '25px'}} />
                                    </a>
                                    <div className="dropdown-menu">
                                    <a className="dropdown-item" role="button"
                                    onClick={() => {
                                        history.push(`/badges/${item.id}/edit`);
                                    }}
                                    > {t('genDict.Edit')}</a>
                                    <a role="button" className="dropdown-item"
                                    onClick={() => confirm({
                                        icon: <ExclamationCircleOutlined/>,
                                        title: t('genDict.confirmDelete'),
                                        okText: t('genDict.ok'),
                                        cancelText: t('genDict.cancel'),
                                        content: `${t('genDict.confirmDelete')} "${item.title.en}"`,
                                        okButtonProps: { loading: deletingItem, danger: true },
                                        onOk: async () => {
                                            setDeletingItem(true);
                                            API_SERVICE.removeBadge(item.id).then((d) => {
                                                notification.success({
                                                    message: t('genDict.success'),
                                                });
                                                // refreshItems();
                                                history.goBack();
                                            }).catch((e: any) => {
                                                notification.error({
                                                    message: t(API_SERVICE.handleErrors(e)),
                                                });
                                            }).finally(() => {
                                                setDeletingItem(false);
                                            });
                                        },
                                    })
                                }
                                    >{t('genDict.delete')}</a>
                                    </div>
                                </span>
                            </div>
                            </div>
                            <div className="row">
                            <div className="col-md-12 pb-3">
                                <div className="table-responsive mt-2">
                                    <table className="table course-details-table box-shadow">
                                        
                                        <tbody>
                                        <tr>
                                            <td className="w-280px text-secondary">{t('genDict.title')}</td>
                                            <td>
                                                {
                                                    Parameters.DefaultLang === 'de' ? item.title.de : ''
                                                }
                                                {
                                                    Parameters.DefaultLang === 'en' ? item.title.en : ''
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-280px text-secondary">{t('genDict.description')}</td>
                                            <td> 
                                                {
                                                    Parameters.DefaultLang === 'de' ? item.description.de : ''
                                                }
                                                {
                                                    Parameters.DefaultLang === 'en' ? item.description.en : ''
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-280px text-secondary">{t('genDict.numberOfCourses')}</td>
                                            <td>{item.no_of_courses}</td>
                                        </tr>
                                        <tr>
                                            <td className="w-280px text-secondary">{t('genDict.Active')}</td>
                                            <td>
                                                {
                                                    item.status === 'ACTIVE' ? 'YES' : 'No'
                                                }
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </div>
                        </div>
                        :''
                        }
                        </div>
                    </div>
                </div>
            </div>
    );
}
